export default "__VITE_ASSET__DPhXrYWF__"